const urlRegex = /((https?:\/\/)?(www\.)?[a-zA-Z0-9\-]+\.[a-zA-Z]{2,}(\S*))/gi;
const markdownLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g;
/**
 * Parses a chat message string into typed segments.
 * - Markdown links `[label](url)` → `{ kind: 'link', label, url }`
 * - Bare URLs `https://...` → `{ kind: 'link', label: url, url }`
 * - Everything else → `{ kind: 'text', value }`
 */
export function parseMessageSegments(text) {
    const segments = [];
    let lastIndex = 0;
    // First pass: extract markdown links
    const mdMatches = [...text.matchAll(markdownLinkRegex)];
    mdMatches.forEach(match => {
        const start = match.index ?? 0;
        if (start > lastIndex) {
            segments.push({ kind: 'text', value: text.slice(lastIndex, start) });
        }
        segments.push({ kind: 'link', label: match[1], url: match[2] });
        lastIndex = start + match[0].length;
    });
    if (lastIndex < text.length) {
        segments.push({ kind: 'text', value: text.slice(lastIndex) });
    }
    // Second pass: expand bare URLs inside text segments
    return segments.flatMap(seg => {
        if (seg.kind !== 'text')
            return [seg];
        const parts = [];
        let idx = 0;
        for (const m of seg.value.matchAll(urlRegex)) {
            const s = m.index ?? 0;
            if (s > idx)
                parts.push({ kind: 'text', value: seg.value.slice(idx, s) });
            const raw = m[0];
            parts.push({
                kind: 'link',
                label: raw,
                url: raw.startsWith('http') ? raw : `https://${raw}`,
            });
            idx = s + raw.length;
        }
        if (idx < seg.value.length)
            parts.push({ kind: 'text', value: seg.value.slice(idx) });
        return parts.length > 0 ? parts : [seg];
    });
}
